import React, { Component } from 'react'
import Cookies from 'universal-cookie'
import queryString from 'query-string'
import SelectField from '../SelectField'
import TextField from '../TextField'
import RadioField from '../RadioField'
import genderBg from '../../images/genderBg.png'
import ageBg from '../../images/ageBg.png'
import locationBg from '../../images/locationBg.png'
import constants from '../../constants'

let ages = []
for(let i = 18; i <= 99; i++) {
  ages.push({label: `${i}`, value: `${i}`})
}

class StartSignupWidget extends Component {
  state = {
    gender: '',
    ageInterestedLow: "",
    ageInterestedHigh: "",
    postalCode: '',
    errors: {},
  }

  handleChange = (field, value) => {
    this.setState({ [field]: value })
  }

  componentDidMount() {
    // Was a promo code passed?  Save it to a cookie
    const promo = queryString.parse(window.location.search).promo
    if(promo) {
      const cookies = new Cookies()
      const cookieArgs = {path: '/', domain: constants.cookieDomain}
      cookies.set("promo", promo, cookieArgs)
    }
  }

  render() {
    const { submitUrl } = this.props
    const { gender, ageInterestedLow, ageInterestedHigh, postalCode, errors } = this.state

    return (
      <form method="GET" action={submitUrl}>
        <div className="start__signup__wrapper">
          <h4>Start Your Journey Here:</h4>

          <div className="start__signup__boxes">
            <div className="start__signup__box" style={{backgroundImage: `url(${genderBg})`}}>
              <div className="start__signup__form__label">I would like to meet:</div>
              <div className="start__signup__form__group">
                <div>
                  <RadioField
                    name="gender"
                    label="A Man"
                    checked={gender === "F"}
                    value="F"
                    onChange={() => this.setState({gender: "F"})}
                  />
                </div>
                <div className="start__signup__form__sep">or</div>
                <div>
                  <RadioField
                    name="gender"
                    label="A Woman"
                    checked={gender === "M"}
                    value="M"
                    onChange={() => this.setState({gender: "M"})}
                  />
                </div>
              </div>
            </div>

            <div className="start__signup__box" style={{backgroundImage: `url(${ageBg})`}}>
              <div className="start__signup__form__label">Between the Ages Of:</div>
              <div className="start__signup__form__group">
                <div className="start__signup__form__select__wrapper">
                  <SelectField
                    name="age_interested_low"
                    availableValues={ages}
                    value={ageInterestedLow}
                    onChange={ageInterestedLow => this.setState({ageInterestedLow})}
                    error={errors.ageInterestedLow}
                  />
                </div>
                <div className="start__signup__form__sep">and</div>
                <div className="start__signup__form__select__wrapper">
                  <SelectField
                    name="age_interested_high"
                    availableValues={ages}
                    value={ageInterestedHigh}
                    onChange={ageInterestedHigh => this.setState({ageInterestedHigh})}
                    error={errors.ageInterestedHigh}
                  />
                </div>
              </div>
            </div>

            <div className="start__signup__box" style={{backgroundImage: `url(${locationBg})`}}>
              <div className="start__signup__form__label">Near Me:</div>
              <div className="start__signup__form__group">
                <TextField
                  name="postal_code"
                  placeholder="Your Zip"
                  value={postalCode}
                  onChange={postalCode => this.setState({postalCode})}
                  error={errors.postalCode}
                />
              </div>
            </div>
          </div>

          <input type="submit" value="Start Searching" className="start__signup__submit" />
        </div>
      </form>
    )
  }
}

export default StartSignupWidget



// WEBPACK FOOTER //
// ./src/components/StartSignupWidget/index.js